module.exports = __webpack_public_path__ + "static/media/landline-logo.85921565.svg";